import { LiveClassEventType } from './consts';

function getBaseDoc(type, classId, creatorId, companyId) {
  const date = new Date();
  return {
    type,
    classId,
    creatorId,
    companyId,
    createdAt: date,
    updatedAt: date
  };
}

export default function createLiveClassDoc(type, params) {
  switch (type) {
    case LiveClassEventType.CARD_CHANGED: {
      const { classId, creatorId, companyId, cardId } = params;
      return {
        ...getBaseDoc(type, classId, creatorId, companyId),
        cardId
      };
    }
    case LiveClassEventType.CARD_COMPLETE: {
      const { classId, userId, companyId, contentId, cardId } = params;
      return {
        ...getBaseDoc(type, classId, userId, companyId),
        userId,
        contentId,
        cardId
      };
    }
    case LiveClassEventType.CHAT: {
      const { classId, userId, companyId, message } = params;
      return {
        ...getBaseDoc(type, classId, userId, companyId),
        userId,
        message
      };
    }
    default:
      return null;
  }
}
